import React from 'react';
import { Box, Flex, Text, HStack } from '@chakra-ui/react';
import { PHRTracker, TrackerTypeEnum } from '../../../../../generated';
import moment from 'moment';

interface IProps {
  onClick: () => void;
  color?: string;
  value?: any;
  getTrackerDisplayValue: any;
  type: TrackerTypeEnum;
  moodTrackers: PHRTracker[];
}

const MoodTrackerItem = ({
  onClick,
  color,
  getTrackerDisplayValue,
  type,
  moodTrackers,
}: IProps) => {
  const item = moodTrackers.find((x) => x.trackerTypeEnum === type);
  const value = getTrackerDisplayValue(type)?.value;
  const date = getTrackerDisplayValue(type)?.date;

  return (
    <Flex
      flexDir="column"
      justify="space-between"
      padding="1.25rem"
      background="#FFFFFF"
      borderRadius="lg"
      h="225px"
      // w="100%"
      cursor="pointer"
      onClick={onClick}
      // w={{ base: '100%', md: '40%' }}
      // m={{ base: 2, md: 2 }}
      // boxSizing="content-box"
    >
      <>
        <HStack spacing={4}>
          <Box w="28px" h="28px" borderRadius="lg" bgColor={color} />
          <Text fontSize="12px" textTransform="uppercase" color="#414F65">
            {item?.name}
          </Text>
        </HStack>

        <Text fontSize="24px" fontWeight="semibold">
          {value}
        </Text>

        <Text fontSize="12px" color="#414F65">
          Updated {moment(date).fromNow()}
        </Text>
      </>
    </Flex>
  );
};

export default MoodTrackerItem;
